import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  cardStyle: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'stretch',
    boxShadow: 'unset',
    border: '1px solid #E7E7E7',
    boxSizing: 'border-box',
    borderRadius: '5px',
  },
  gridMargin: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));
